import tokeys from 'tokeys';

export const CardType = tokeys(['plastic', 'plasticless']);
